import { createSelector, createStructuredSelector } from 'reselect';

import { StoreType } from '@tock/shared/utils/connect';
import { filter, keyBy } from 'es-toolkit/compat';

export const guestGroupsSelector = createStructuredSelector<
  StoreType,
  { guestGroups: StoreType['guestGroups'] }
>({
  guestGroups: (state: StoreType): StoreType['guestGroups'] => {
    return state.guestGroups;
  },
});

export const dynamicGroupsSelector = createSelector(guestGroupsSelector, (guestGroups) =>
  filter(guestGroups.guestGroups.data, (guestGroup) => {
    return guestGroup.type === 'RULE_BASED';
  })
);

export const guestGroupsByIdSelector = createSelector(guestGroupsSelector, (guestGroupsState) => {
  const { data } = guestGroupsState.guestGroups;
  return keyBy(data, 'id');
});
